<app-loading *ngIf="loading"></app-loading>
<form [formGroup]="formulario" *ngIf="!loading">
<div class="grid d-flex align-items-center">
  <div class="col-4 md:col-4 lg:col-4" *ngIf="!esDetalle">
    <div class="div-form">
      <label>* {{ 'MODALIDADES.LBL_MODALIDADBURO' | translate }}</label>
      <p-multiSelect id="idTipoObligacion" name="obligacion" [options]="listasTiposObligacionesDataCredito" filter="filter"
                     defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                     selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                     formControlName="idTipoObligacion"
                     optionLabel="label"
                     optionValue="value"
                     emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                     emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
      ></p-multiSelect>
      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoObligacion.invalid">
        {{ 'MODALIDADES.LBL_MODALIDADBURO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
      </div>
    </div>
  </div>
  <div class="col-2 md:col-2 lg:col-2" *ngIf="!esDetalle">
    <div class="div-form">
      <label>* {{ 'MODALIDADES.LBL_FACTORCREZCAMOS' | translate }}</label>
      <input type="text" id="factorCrezcamos" name="factorCrezcamos" pInputText
             formControlName="factorCrezcamos"
             maxlength="10" numero-decimal-reactive [entero]="3" [decimales]="6"/>
      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted  && f.factorCrezcamos.invalid">
        {{ 'MODALIDADES.LBL_FACTORCREZCAMOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
      </div>
    </div>
  </div>
  <div class="col-2 md:col-2 lg:col-2 pt-4" *ngIf="!esDetalle">
    <div class="div-form">
      <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                  id="indicadorHabilitado"
                  name="indicadorHabilitado"
                  formControlName="indicadorHabilitado"></p-checkbox>
    </div>
  </div>
  <div class="col-4 md:col-4 lg:col-4 pt-4" *ngIf="!esDetalle" >
    <div *ngIf="!guardando" style="display: flex; align-items: center">
      <a (click)="cancelar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
      <button icon="fa fa-plus" label="{{ 'BTN_AGREGAR' | translate}}"
              type="submit"
              pButton (click)="agregar()"></button>
    </div>
    <div *ngIf="guardando">
      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
      <span>{{'LBL_GUARDANDO' | translate }}</span>
    </div>
  </div>
</div>
</form>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <app-loading *ngIf="guardando"></app-loading>
    <p-table [columns]="columnas" *ngIf="!guardando"
             [value]="listaModalidadesFactorCrezcamos" selectionMode="single" dataKey="idModalidadFcatorCrezcamos"
             [paginator]="true" [rows]="5"  paginatorPosition="bottom">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td class="text-center">{{row.tipoObligacion}}</td>
          <td class="text-center">{{row.factorCrezcamos}}</td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true"
                        [disabled]="true"></p-checkbox>
          </td>

          <td *ngIf="!esDetalle" class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                      title="{{'BTN_EDITAR' | translate}}" pButton
                      (click)="editar(row)"></button>

            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ 'MSG_NOHAYREGISTROS' | translate}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-confirmDialog #cd key="cancelar-edit" appendTo="body">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

